import React from 'react';
import {
    Table
} from 'reactstrap';
import { jwtDecode } from 'jwt-decode';
import { aesUtil } from '../utils/aesUtil';

function Profile() {
    let data = localStorage.getItem('token');
    const decryptToken = typeof data === 'string' ? aesUtil.decrypt(data) : '';
    const profile = typeof decryptToken === 'string' ? jwtDecode(decryptToken) : null;

    return (
        <div>
            <div className="pos-stick">
                <div className="Body_topBar">
                    <div className="left">
                        <h5 className="fw-bold mb-0">My Profile</h5>
                    </div>
                    <div className="right">

                    </div>
                </div>

                <div className="table-responsive ">
                    <Table>
                        {/* <thead>
                            <tr>
                                <th></th>
                                <th></th>
                            </tr>
                        </thead> */}
                        <tbody>
                            <tr>
                                <td className='tbl-w-35'>
                                    <strong>Name</strong>
                                </td>
                                <td>{profile?.Name ? profile?.Name : ''}</td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>Role</strong>
                                </td>
                                <td>{profile?.Role ? profile?.Role : '--'}</td>
                            </tr>

                            <tr>
                                <td>
                                    <strong>Email ID</strong>
                                </td>
                                <td>{profile?.Email ? profile?.Email : '--'}</td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>Contact Number</strong>
                                </td>
                                <td>{profile?.MobileNo ? profile?.MobileNo : '--'}</td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>Employee Number</strong>
                                </td>
                                <td>{profile?.EmployeeNo ? profile?.EmployeeNo : '--'}</td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>{profile?.Role === "Insurer" ? 'Insurance Company ' : 'Surveyor Company '}Name</strong>
                                </td>
                                <td>{profile?.InsuranceCompanyName ? profile?.InsuranceCompanyName : '--'}</td>
                            </tr>

                        </tbody>
                    </Table>
                </div>



            </div>

        </div>
    );
}
export default Profile;